import React from 'react';

interface IconProps {
  color?: string;
}

function Icon({ color = '#D3E1FF' }: IconProps): JSX.Element {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="111" height="117" fill="none" viewBox="0 0 111 117">
      <path
        fill={color}
        fillRule="evenodd"
        d="M80.141 40.698a23.34 23.34 0 0 1 13.802 1.7 3.335 3.335 0 0 1 .983 5.393L82.391 60.324l-.01.006 5.286 5.287 12.546-12.543.303-.27a3.336 3.336 0 0 1 5.091 1.253 23.35 23.35 0 0 1-4.759 26.12 23.328 23.328 0 0 1-23.93 5.615L55.425 107.29a10.405 10.405 0 0 1-14.713-14.714L62.205 71.08a23.34 23.34 0 0 1 5.619-23.926 23.34 23.34 0 0 1 12.317-6.455m6.048 6.397a16.7 16.7 0 0 0-4.853.162 16.669 16.669 0 0 0-12.197 23.268c.571 1.264.3 2.75-.68 3.731L45.424 97.29a3.74 3.74 0 0 0 0 5.286 3.74 3.74 0 0 0 5.286 0l23.034-23.033.39-.336a3.34 3.34 0 0 1 3.34-.345 16.67 16.67 0 0 0 9.86 1.214 16.67 16.67 0 0 0 13.408-13.411 16.7 16.7 0 0 0 .16-4.854l-8.568 8.568a6.67 6.67 0 0 1-4.668 1.908 6.67 6.67 0 0 1-4.664-1.908l-.026-.023-5.333-5.332-.022-.026a6.67 6.67 0 0 1-1.908-4.664c0-1.745.686-3.423 1.908-4.668z"
        clipRule="evenodd"
      ></path>
      <path fill={color} d="M40.031 56.667a3.333 3.333 0 1 1 0 6.666H40a3.333 3.333 0 1 1 0-6.666z"></path>
      <path
        fill={color}
        fillRule="evenodd"
        d="M56.665 3.334c5.523 0 10 4.477 10 10v53.333c0 5.523-4.477 10-10 10H23.332c-5.523 0-10-4.477-10-10V13.334c0-5.523 4.477-10 10-10zM23.332 10a3.333 3.333 0 0 0-3.333 3.334v53.333A3.333 3.333 0 0 0 23.332 70h33.333A3.333 3.333 0 0 0 60 66.667V13.334A3.333 3.333 0 0 0 56.665 10z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}

export default Icon;
